import { useState } from 'react'

/**
 * OrderReconfirmCart
 * Renders a reconfirmation popup for cart redemption, handles OTP sending and popup state.
 */
import { BalanceCard } from '../projectData'
import { sendOTP } from '../api';
import OrderConfirmPopup from './orderConfirmPopup';

const OrderReconfirmCart = ({ mobile, project_key, dashboard, setReconfirm, cartItems }) => {
    const [status, setStatus] = useState(null);




    /**
     * handleClick
     * Handles the click event to send OTP and update popup state.
     */
    const handleClick = async (value) => {


        if (mobile && project_key) {
            try {
                //setStatus('ok')
                const response = await sendOTP({
                    mobile: mobile,
                    project_key: project_key,
                    type: 'redemption'
                });
                if (Number(response.code) === 1) {
                    setStatus('ok')
                } else {
                    setStatus(response.message || 'Failed to send OTP');
                }
            } catch (error) {
                setStatus(error?.response?.data?.message);

            } finally {
                //setLoading(false);
            }
        }
    }
    return (
        <>
            {status === "ok" ?
                <>
                    <OrderConfirmPopup reSendOtp={handleClick} setShowTerms={setStatus} mobile={mobile} project_key={project_key} />
                </>
                : <> <div className="card p-2  mb-4 border rounded" style={{ backgroundColor: "#FBF6F7", border: "1px solid #848484" }}>
                    <div className="card-body p-3">
                        <div className=' fs-5'> Do you wish to continue with this redemption?  </div>
                        <div className=' fs-5'>  Please note, once confirmed, it cannot be cancelled or altered in any manner.</div>
                        {status && <div className='text-danger fs-5'> {status} </div>}

                    </div>
                </div>
                    <div className="card shadow-sm mb-4 " style={{ borderRadius: '150px' }} >
                        <div className="card-header d-flex justify-content-between align-items-center bg-dark text-white p-4"
                            style={{ borderRadius: '15px 15px 0 0', minHeight: "15px" }}
                        > <strong>Redeem Items</strong></div>
                        <div className="card-body p-0 border">
                            <ul className="list-group list-group-flush">
                                {cartItems?.map((item) => (
                                    <li className="list-group-item">
                                        <div className="d-flex justify-content-between">
                                            <span className="fs-6 fw-semibold">{item?.sku_name}</span>
                                        </div>
                                        <div className="d-flex gap-4">
                                            <span className="text-danger fw-semibold fs-6">{item?.redeemed_point} Pts</span>
                                            <span className="fs-6 fw-semibold">QTY: {item?.quantity}</span>
                                        </div>
                                    </li>))}
                            </ul>
                        </div>
                    </div>
                    <BalanceCard totalBalance={dashboard?.totalBalance} totalPoints={dashboard?.this_cart_point} />
                    <div className="mt-4 mb-10 d-flex gap-4 sticky-bottom">
                        <button onClick={() => setReconfirm(false)} className="btn btn-sm fs-3 btn-dark w-100 py-4">
                            No
                        </button>
                        <button onClick={() => handleClick(true)} className="btn btn-sm fs-3 btn-danger w-100 py-4">
                            Yes
                        </button>
                    </div>

                </>

            }
        </>
    )
}

export default OrderReconfirmCart